import { ReactComponent as Icon } from "../images/dollar.svg";

const Dollar  = ({ size = "120", color = "#5EC394" }) => {
  return (
    <>
      <Icon width={size} height={size} fill={color} />
    </>
  );
};
export default Dollar;
